var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepageDecor1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 353,
    viewBox: "0 0 151 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.3387 347.771C12.0462 332.236 -4.52481 315.041 -20.6795 297.397C-36.6914 279.614 -52.2077 261.46 -65.8828 241.74C-47.576 257.262 -31.0118 274.456 -14.8645 292.114C1.13334 309.903 16.6428 328.057 30.3322 347.764L30.3387 347.771Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2703 334.445C21.3149 317.08 3.08754 298.061 -14.7235 278.593C-32.3917 258.986 -49.5643 239.009 -64.9023 217.458C-44.9327 234.81 -26.7056 253.835 -8.9085 273.31C8.74569 292.923 25.9115 312.9 41.2703 334.445Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1948 321.112C30.5765 301.916 10.693 281.067 -8.77434 259.775C-28.0923 238.352 -46.9212 216.55 -63.9219 193.162C-42.2893 212.345 -22.4061 233.201 -2.95274 254.499C16.3578 275.936 35.1796 297.744 52.1948 321.112Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1113 307.807C39.8366 286.787 18.2969 264.114 -2.82684 240.998C-23.8011 217.751 -44.2861 194.119 -62.9434 168.914C-39.6545 189.921 -18.115 212.6 2.99476 235.722C23.9547 258.983 44.4401 282.608 63.1113 307.807Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0791 294.428C24.8227 248.195 -20.7406 198.055 -61.959 144.529C-12.6672 190.736 32.8253 240.928 74.0791 294.428Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0469 281.056C32.4516 231.147 -16.4241 177.353 -60.9746 120.151C-8.35071 170.033 40.4608 223.887 85.0469 281.056Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.015 267.684C40.0875 214.099 -12.1005 156.65 -59.9902 95.7792C-4.03394 149.331 48.0968 206.839 96.015 267.684Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.982 254.298C47.7294 197.045 -7.7847 135.941 -59.0068 71.4011C0.281843 128.622 55.7318 189.784 106.982 254.298Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.0215 47.0023L-49.1221 56.8048L-48.9059 57.0606L117.957 240.926",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.0215 47.0023C-26.8327 76.7215 3.75104 109.525 32.8914 141.351C61.754 173.426 91.4287 206.982 117.957 240.926C86.7528 211.254 56.1639 178.409 27.0372 146.584C-1.80452 114.503 -31.5129 80.9316 -58.0215 47.0023Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.0381 22.6378L-36.5513 45.2063L-36.3285 45.4692L128.925 227.547",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.0381 22.6378C-24.2056 54.1528 8.08656 88.8509 38.8704 122.479C69.3762 156.364 100.753 191.801 128.925 227.547C96.0842 196.066 63.7792 161.347 33.0093 127.712C2.51729 93.8281 -28.8723 58.3703 -57.0381 22.6378Z",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.5742 0.102905L-23.1497 33.4491L-22.9269 33.712L142.333 215.79",
    fill: "#FAE632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.5742 0.102905C14.8912 68.7568 81.796 140.017 142.333 215.79C72.5704 148.162 8.59043 74.6789 -53.5742 0.102905Z",
    fill: "#FAE632"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageDecor1);
export default __webpack_public_path__ + "static/media/homepage-decor-1.f59509a2b57f393ccf0961b0161046d9.svg";
export { ForwardRef as ReactComponent };